import style from "./ProfileContent.module.css";
import { Outlet } from "react-router-dom";
import Container from "@/layouts/container/Container";

import ProfileReviewCards from "../profileReviewCards/ProfileReviewCards";
import UserActivity from "@/features/activityStreak/components/userActivity/UserActivity";

function ProfileContent({ username }) {
	return (
		<Container>
			<div className={style.grid}>
				<div className={style.side}>
					<UserActivity username={username} />
					<ProfileReviewCards username={username} />
				</div>
				<div className={style.main}>
					<Outlet />
				</div>
			</div>
		</Container>
	);
}

export default ProfileContent;
